import { memo } from 'react';
import packageArrow from '../../assets/images/package-arrow.png';

// Helper to format USD values
const formatUSD = (value) =>
  value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });

// Sync with backend enum
const packages = [
  {
    id: 'January 2027 retreat',
    title: 'LIVE Online Retreat Package',
    description: 'January 2027 Retreat Deposit',
    total: 1_495,
    old_price: 1_595,
    save: 100,
    deposit: 721,
    features: [
      'Daily Meditations',
      'Daily Guided Meal with Geneen',
      'Interactive Groups with Geneen',
      'Ongoing Support Programs',
      'Video Recordings for review',
    ],
  },
];

const RegisterPackage = ({ nextStep }) => (
  <div className="flex flex-wrap flex-col justify-center items-center gap-4 mb-8">
    {packages.map((pkg) => (
      <div key={pkg.id} className="w-[386px] flex flex-col">
        {/* Asterisk notice (optional) */}
        {pkg.asterisk && (
          <div className="relative mx-6 mb-1">
            <span className="text-sm font-semibold text-secondary">* {pkg.asterisk}</span>
            <img
              src={packageArrow}
              alt="Down arrow"
              role="presentation"
              className="absolute h-full right-0 top-0"
            />
          </div>
        )}
        {/* Card */}
        <div className="flex flex-col bg-white rounded-3xl shadow-md flex-1 h-fit">
          {/* Header */}
          <h2 className="block px-8 py-4 text-2xl text-center font-roboto font-normal leading-[1.334] tracking-normal bg-[#9aeeda] rounded-t-[32px]">
            {pkg.title}
          </h2>
          {/* Content */}
          <div className="flex flex-col p-6 flex-1">
            {/* Charges */}
            <div className="flex flex-col items-center mb-4">
              {pkg.old_price ? (
                <>
                  {/* Mensaje de ahorro */}
                  <span className="text-2xl font-roboto text-red-600 font-bold">
                    Register Now and Save
                  </span>
                  {/* Precios */}
                  <div className="flex items-center gap-4 my-1">
                    {/* Precio tachado */}
                    <span
                      className="relative inline-block select-none mx-2
                                before:block before:absolute
                                before:top-1/2 before:left-[-5%]
                                before:w-[110%] before:h-[2px]
                                before:bg-red-600 before:-rotate-[10deg]
                                before:origin-center"
                    >
                      <span className="text-xl font-roboto font-medium tracking-[0.0075em]">
                        {formatUSD(pkg.old_price)}
                      </span>
                    </span>
                    {/* Precio rebajado */}
                    <span className="text-xl font-roboto font-medium tracking-[0.0075em] text-red-600">
                      {formatUSD(pkg.total)}
                    </span>
                  </div>
                  <span className="text-xl font-roboto font-normal">
                    Early Bird Rate
                  </span>
                </>
              ) : (
                <>
                  <span className="text-2xl font-roboto text-red-600">
                    Register Now and Save
                  </span>
                  <span className="text-2xl my-1">{formatUSD(pkg.total)}</span>
                </>
              )}
            </div>
            {/* Features */}
            <ul className="flex-1 border-t border-gray-200 py-4 px-6 list-disc list-inside text-sm space-y-1 text-left">
              {pkg.features.map((feature) => (
                <li key={feature} className='px-6 text-base font-roboto font-normal leading-[1.5] tracking-[0.00938em]'>{feature}</li>
              ))}
            </ul>
            {/* Deposit */}
            <div className="flex flex-col items-center mb-4">
              <span className="text-2xl font-roboto font-normal leading-none tracking-normal text-red-600">
                {formatUSD(pkg.deposit)}**
              </span>
              <span className="text-xs">Deposit Due Now</span>
            </div>
            {/* Action */}
            <button
              className=" bg-gradient-to-r from-pink-500 to-pink-400 hover:from-pink-600 hover:to-pink-500 text-white font-semibold py-2 px-6 rounded-full shadow-lg transition-colors duration-300"
              onClick={() => nextStep({ package: pkg.id })}
            >
              Reserve your spot now
            </button>
          </div>
        </div>
      </div>
    ))}
    {/* Footnote */}
    <div className="text-base font-roboto font-normal leading-[1.5] tracking-[0.00938em]">
      <span className="text-red-600 text-3xl leading-none align-top mr-1">*</span>
      Credit card payments include a 3.75% processing fee. Contact us with any questions at:
      <a href="mailto:retreats@geneenroth.com" className="text-emerald-600 no-underline ml-1">
        retreats@geneenroth.com
      </a>
      {' '}or
      <a href="tel:+1-703-401-0871" className="text-emerald-600 no-underline ml-1">703-401-0871</a>.
    </div>
  </div>
);

export default memo(RegisterPackage);
